module.exports = __webpack_public_path__ + "static/media/LoadingBlue.fef1f20a.gif";